const childRoutes = (prop) => [
    {
        path: 'service-type',
        name: prop + '.service_type',
        meta: { auth: true },
        component: () => import('../pages/service-type/List.vue')
    },
    {
        path: 'service-process-step',
        name: prop + '.service_process_step',
        meta: { auth: true },
        component: () => import('../pages/service-process-step/List.vue')
    },
    {
        path: 'service-process-avail',
        name: prop + '.service_process_avail',
        meta: { auth: true },
        component: () => import('../pages/service-process-avail/List.vue')
    },
    {
        path: 'eligibility-category',
        name: prop + '.eligibility_category',
        meta: { auth: true },
        component: () => import('../pages/eligibility-category/List.vue')
    },
    {
        path: 'patient-category',
        name: prop + '.patient_category',
        meta: { auth: true },
        component: () => import('../pages/patient-category/List.vue')
    },
    {
        path: 'event-info-setup',
        name: prop + '.event_info_setup',
        meta: { auth: true },
        component: () => import('../pages/event-info-setup/List')
    },
    {
        path: 'supplier-info',
        name: prop + '.supplier-info',
        meta: { auth: true },
        component: () => import('../pages/supplier-info/List.vue')
    },
    {
        path: 'faq-setup',
        name: prop + '.faq-setup',
        meta: { auth: true },
        component: () => import('../pages/faq-setup/List.vue')
    },
    {
        path: 'event-type-setup',
        name: prop + '.event_type_setup',
        meta: { auth: true },
        component: () => import('../pages/event-type-setup/List.vue')
    },
    {
        path: 'fair-stall-fee-setup',
        name: prop + '.fair_stall_fee_setup',
        meta: { auth: true },
        component: () => import('../pages/fair-stall-fee-setup/List.vue')
    },
    {
        path: 'fair-evaluation-setup',
        name: prop + '.fair_evaluation_setup',
        meta: { auth: true },
        component: () => import('../pages/fair-evaluation-setup/List.vue')
    },
    {
        path: 'stall-setup',
        name: prop + '.stall_setup',
        meta: { auth: true },
        component: () => import('../pages/stall-setup/List.vue')
    },
    {
        path: 'report-heading-list',
        name: prop + '.report_heading_list',
        meta: { auth: true },
        component: () => import('../pages/report-heading/List.vue')
    },
    {
        path: 'stall-type',
        name: prop + '.stall_type',
        meta: { auth: true },
        component: () => import('../pages/stall-type/List.vue')
    },
    {
        path: 'education-level',
        name: prop + '.education_level',
        meta: { auth: true },
        component: () => import('../pages/education-level/List.vue')
    },
    {
        path: 'group',
        name: prop + '.group',
        meta: { auth: true },
        component: () => import('../pages/group/List.vue')
    },
    {
        path: 'institute',
        name: prop + '.institute',
        meta: { auth: true },
        component: () => import('../pages/institute/List.vue')
    },
    {
        path: 'skill',
        name: prop + '.skill',
        meta: { auth: true },
        component: () => import('../pages/skill/List.vue')
    },
    {
        path: 'degree',
        name: prop + '.degree',
        meta: { auth: true },
        component: () => import('../pages/degree/List.vue')
    },
    {
        path: 'activity-log',
        name: prop + '.activity_log',
        meta: { auth: true },
        component: () => import('../pages/activity-log/List.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/configuration',
    name: 'awareness_event_service.configuration',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.configuration')
}]

export default routes
